// extracted by mini-css-extract-plugin
var _1 = "ListingProfilePublishingsPortalCell-modulelogo__ArU2C";
export { _1 as "logo" }
